import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { withFragments } from '@sorare/core/src/lib/gql';

import type { getNbDecks_publicUserInfoInterface } from './__generated__/getNbDecks.graphql';

export const getNbDecks = withFragments(
  (publicUserInfoInterface: Nullable<getNbDecks_publicUserInfoInterface>) => {
    return (
      publicUserInfoInterface?.anyUserSportProfile?.decks.nodes.length ?? 0
    );
  },
  {
    publicUserInfoInterface: gql`
      fragment getNbDecks_publicUserInfoInterface on PublicUserInfoInterface {
        slug
        anyUserSportProfile(sport: $sport) {
          id
          decks {
            nodes {
              slug
            }
          }
        }
      }
    ` as TypedDocumentNode<getNbDecks_publicUserInfoInterface>,
  }
);
